module.exports = __webpack_public_path__ + "static/media/adsum.06122ca8.svg";